import React, { Component } from "react";
import { ApolloClient } from "@apollo/client";
import { withRouter, Switch, RouteComponentProps, Route } from "react-router-dom";
import { flowRight as compose } from "lodash";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import PrivateRoute from "components/PrivateRoute";
import EnvIndicator from "components/EnvIndicator";
import Window from "components/Layout/Window";
import { handleStandaloneLocation } from "utilities/standalone";
import { getAppUrl } from "utilities/routes";
import { UserInfoQuery, withUserInfoNoCache } from "modules/Dashboard/UserInfo";

import GigInfo from "./GigInfo";
import Settings from "./Settings";
import Intercom from "./Intercom";
import i18n from "./i18n";
import LoadingContainer from "components/LoadingContainer";
import GroupDocuments from "./Report/GroupDocuments";

type Props = RouteComponentProps &
  UserInfoQuery & {
    client: ApolloClient<any>;
  };

class App extends Component<Props> {
  public componentDidMount() {
    handleStandaloneLocation(this.props.history);

    i18n.changeLanguage("en-US");
  }

  public render() {
    const { me } = this.props.userInfo;

    return (
      <React.Suspense fallback={<LoadingContainer />}>
        <Window>
          <EnvIndicator />

          {me && <Intercom me={me} />}
          <div>
            <Switch>
              <PrivateRoute path="/:orgId/gigs/:id" component={GigInfo} />
              <PrivateRoute path="/gigs/:id" component={GigInfo} />
              <PrivateRoute path="/s/:hash" component={GigInfo} />
              <PrivateRoute path="/:orgId/settings" component={() => <Settings />} />
              <PrivateRoute path="/settings" component={() => <Settings />} />
              <PrivateRoute path="/groups/:groupId/documents" component={GroupDocuments} />
              <Route
                path="*"
                render={() => {
                  window.location.href = getAppUrl("go");
                  return null;
                }}
              />
            </Switch>
          </div>
        </Window>
      </React.Suspense>
    );
  }
}

export default compose(withRouter, withUserInfoNoCache)(App);
